import { render, staticRenderFns } from "./FaceToFaceCustomer.vue?vue&type=template&id=76807d5a&"
import script from "./FaceToFaceCustomer.vue?vue&type=script&lang=js&"
export * from "./FaceToFaceCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports